import { RouterProvider } from "react-router-dom";
import { AppProviders } from "@/app/providers";
import { router } from "@/app/router";

export function App() {
  return (
    <div data-testid="app">
      <AppProviders>
        <RouterProvider router={router} />
      </AppProviders>
    </div>
  );
}
